import { render, staticRenderFns } from "./PorPagar.vue?vue&type=template&id=49e72b3b&"
import script from "./PorPagar.vue?vue&type=script&lang=ts&"
export * from "./PorPagar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports